import type { CalendarDate, CustomListItemId, CustomListKey, Maybe } from "@sp-crm/core";
import type { AppRouter } from "@sp-crm/server/rpc";
import type { inferProcedureInput, inferProcedureOutput } from "@trpc/server";
import type { ReactNode } from "react";

export type GlobalClientSearchCriteria = Exclude<
    inferProcedureInput<AppRouter["clients"]["getClientsForDetails"]>,
    void
>;

export type ClientsSearchResult = inferProcedureOutput<
    AppRouter["clients"]["getClientsForDetails"]
>;

export type ClientForDetails = ClientsSearchResult["clients"][number];

export const clientCardType = "ClientCard" as const;

export interface PipelineItem {
    id: string;
    statusListItemId?: CustomListItemId;
}

export interface PipelineCardRenderProps {
    highlightCard: boolean;
    pendingCard: boolean;
    showAssignedTo: boolean;
    getStatusDescription: (item: PipelineItem) => {
        descriptor: string;
        date: Maybe<CalendarDate>;
    };
}

export interface PipelineConfig {
    customListKey: CustomListKey;
    cardType: string;
    useColumnQuery: (
        statusId: CustomListItemId,
        searchCriteria: Record<string, unknown>,
    ) => { data: PipelineItem[] | undefined };
    onDragDrop: (
        entityId: string,
        oldStatusId: CustomListItemId,
        newStatusId: CustomListItemId,
        searchCriteria: Record<string, unknown>,
    ) => Promise<void>;
    renderCard: (item: PipelineItem, renderProps: PipelineCardRenderProps) => ReactNode;
}
